module.exports = __webpack_public_path__ + "images/help/video-todos-small@2x-cb248c6be3e5153c36cd081df42d4d77.png";